import { TfiAlarmClock } from 'react-icons/tfi'
import { Link, useParams } from 'react-router-dom'

import styles from './styles.module.scss'

import { Course } from '@/domain/entities/course.entity'
import { Institution } from '@/domain/entities/institution.entity'

interface IProps {
  course: Course
  institution: Institution
}

export const Details = ({ course, institution }: IProps) => {
  const { id } = useParams()

  return (
    <div className={styles.container}>
      <img />
      <p className={styles.title}>{course?.name}</p>
      <div className={styles.info}>
        <p>
          Turno: <span>{course?.shift}</span>
        </p>
        <p>
          Bairro: <span>{institution?.bairro}</span>
        </p>
        <p>
          Início: <span>{course?.scholarship_year}</span>
        </p>
      </div>
      <div className={styles.price}>
        <div>
          <p>Mensalidade Integral:</p>
          <p>
            Desconto <span>Posso estudar:</span>
          </p>
          <p>Você pagará por mês:</p>
          <p className={styles.scholarships}>
            <TfiAlarmClock size={24} /> Só restam{' '}
            <span>{course?.vacancies} bolsas</span>
          </p>
        </div>
        <div className={styles.column}>
          <p>R$ {course?.amount.toString().replace('.', ',')}</p>
          <p> - {course?.percent?.split(',')[0]}%</p>
          <p>R$ {course?.promotional_value.toString().replace('.', ',')}</p>
        </div>
      </div>
      <p>
        Economize{' '}
        <span>
          R${' '}
          {(
            (Number(course?.amount?.replace(',', '.')) -
              Number(course?.promotional_value?.replace(',', '.'))) *
            12
          )
            ?.toFixed(2)
            ?.replace('.', ',')}{' '}
          / ano
        </span>{' '}
        com essa bolsa!
      </p>
      <Link to={`/register-student/${id}/step-1`} className={styles.FakeButton}>
        Quero essa bolsa!
      </Link>
    </div>
  )
}
